import { render, staticRenderFns } from "./SortBody.vue?vue&type=template&id=aa9329d4&scoped=true&"
import script from "./SortBody.vue?vue&type=script&lang=js&"
export * from "./SortBody.vue?vue&type=script&lang=js&"
import style0 from "./SortBody.vue?vue&type=style&index=0&id=aa9329d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9329d4",
  null
  
)

export default component.exports